import { createContext } from 'react';
import { ApiServicesProviderState } from './types';

export const ApiServicesContext = createContext<ApiServicesProviderState>(null);
